import React from "react";
import LockIcon2 from "assets/images/icons/lock2.png";
import { useNavigate } from "react-router-dom";
import { formatDate, formatToAmPm } from "components/common/Utils";

const ClosureDetailsTooltip = ({ item,setShowTooltip }) => {
    const navigate = useNavigate()
  return (
    <div
      className="closure_tooltip"
      onClick={() =>
        navigate(
          `/management/ws-management/closure-details?id=${item?.closureDetails?._id}`
        )
      }
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="d-flex gap-2">
        <img src={LockIcon2} alt="lock" width={15} height={15} />
        {item?.closureDetails?.type === 1 && (
          <p>
            One-Time Closure —{" "}
            {formatDate(item?.closureDetails?.dateAndTimes?.startDate)} to{" "}
            {formatDate(item?.closureDetails?.dateAndTimes?.endDate)},{" "}
            {formatToAmPm(item?.closureDetails?.dateAndTimes?.startTime)} to{" "}
            {formatToAmPm(item?.closureDetails?.dateAndTimes?.endTime)}
          </p>
        )}
        {item?.closureDetails?.type === 2 && (
          <p>
            Closed every{" "}
            {item?.closureDetails?.dateAndTimes?.daysOfRecurrence?.join(", ")}{" "}
            from {formatToAmPm(item?.closureDetails?.dateAndTimes?.startTime)}{" "}
            {formatToAmPm(item?.closureDetails?.dateAndTimes?.endTime)}
          </p>
        )}
      </div>
    </div>
  );
};

export default ClosureDetailsTooltip;
